import React, { useCallback, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { isChatOpend, isHandlerOpend, isMemberOpend, toggleChat, toggleHandlerEnquries, toggleMember } from '../../sidebar';
import { ClickButton } from '../../ui';
import { isChatRead } from '../../chat';
import { isCheckPermission } from '../../../room';
import { PERMISSION } from '../../members';
const ToggleSideBar = React.memo(({ className, size, mode, isText, iconStyles, label, isDualMonitor,
// enableLable,
 }) => {
    const dispatch = useDispatch();
    const chatRead = useSelector((state) => (mode === 'chat' ? isChatRead(state) : true));
    const { isChat, isMember, isHandler } = useSelector((state) => {
        return {
            isChat: isChatOpend(state),
            isMember: isMemberOpend(state),
            isHandler: isHandlerOpend(state),
        };
    }, shallowEqual);
    const isFocus = useMemo(() => (mode === 'chat' ? (isChat ? true : false) : mode === 'member' ? isMember ? true : false : mode === 'handler' || mode === 'queue' ? isHandler ? true : false : false), [mode, isChat, isMember, isHandler]);
    const onClick = useCallback(() => {
        if (mode === 'chat') {
            // @ts-ignore
            dispatch(toggleChat());
        }
        else if (mode === 'member') {
            // @ts-ignore
            dispatch(toggleMember());
        }
        else if (mode === 'handler' || mode === 'queue') {
            // @ts-ignore
            dispatch(toggleHandlerEnquries());
        }
    }, [mode]);
    const isPermission = useSelector((state) => isCheckPermission(state, PERMISSION.SHOW_MEMBER));
    if (!isPermission && mode === 'member')
        return null;
    return (React.createElement(ClickButton, { className: `chat ${className} ${isFocus ? 'isFocus' : ''}`, isText: isText, icon: mode, size: size, color: isDualMonitor ? '#7786c2' : isFocus ? APP.config.style.focusColor : chatRead ? '#fff' : '#e91e63', label: label, onClick: onClick, styles: iconStyles }));
});
export default ToggleSideBar;
